var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2581 0.79797C16.7463 0.286996 16.0527 0 15.3296 0C14.6064 0 13.9128 0.286996 13.401 0.79797L1.15844 13.0408C0.807854 13.3894 0.529874 13.8041 0.340587 14.2609C0.151299 14.7176 0.0544612 15.2074 0.0556753 15.7018V17.2472C0.0556753 17.4469 0.134982 17.6383 0.276148 17.7795C0.417315 17.9207 0.608778 18 0.808417 18H2.3538C2.84817 18.0014 3.33791 17.9047 3.79466 17.7155C4.25142 17.5264 4.66611 17.2485 5.01474 16.8979L17.2581 4.65435C17.7688 4.14262 18.0557 3.44916 18.0557 2.72616C18.0557 2.00316 17.7688 1.3097 17.2581 0.79797ZM3.95036 15.8335C3.52582 16.2553 2.9522 16.4927 2.3538 16.4945H1.56116V15.7018C1.5604 15.4052 1.61849 15.1113 1.73206 14.8372C1.84563 14.5632 2.01244 14.3144 2.22282 14.1052L11.5139 4.81393L13.2452 6.54527L3.95036 15.8335ZM16.193 3.58995L14.3066 5.47711L12.5753 3.74577L14.4624 1.85861C14.692 1.62902 15.0034 1.50003 15.3281 1.50003C15.4888 1.50003 15.648 1.5317 15.7965 1.59322C15.9451 1.65475 16.08 1.74492 16.1937 1.85861C16.3074 1.97229 16.3976 2.10725 16.4591 2.25578C16.5206 2.40431 16.5523 2.56351 16.5523 2.72428C16.5523 2.88505 16.5206 3.04424 16.4591 3.19277C16.3976 3.34131 16.3074 3.47627 16.1937 3.58995H16.193Z",
    fill: "#0090D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.90c17c8befd61e64ba113b62e54231b2.svg";
export { ForwardRef as ReactComponent };